export const ROUTES = {
  POSITION_PRICE: '/payments/position-price',
  BUY_POSITION: '/payments/buy-position',
};

export const REDUCER_PATH = 'paymentApi';
